import { post } from "../AxiosConfig";

const URI = "/loadingterminal";

const checkTerminalIssues = (payload) => {
    const URL = `${URI}/check-terminal-issues`;
    return post(URL, payload);
};

const fixTerminalIssue = (payload) => {
    const URL = `${URI}/fix-terminal-issue`;
    return post(URL, payload);
};

const deleteCalculationData = (payload) => {
    const URL = `${URI}/delete-calculation-data`;
    return post(URL, payload);
};

const getEmployeesForFix = (payload) => {
    const URL = `${URI}/get-employees-for-fix`;
    return post(URL, payload);
};

const getLocationsForFix = (payload) => {
    const URL = `${URI}/get-locations-for-fix`;
    return post(URL, payload);
};

const TerminalIssuesService = {
    checkTerminalIssues,
    fixTerminalIssue,
    deleteCalculationData,
    getEmployeesForFix,
    getLocationsForFix,
};

export default TerminalIssuesService;